export class ActionBarTimer {
    private readonly callback: () => void;
    private readonly additionalTimers: number[];

    private primaryTimer: number;

    constructor(callback: () => void) {
        this.callback = callback;
        this.additionalTimers = [];
    }

    public start(time: number) {
        this.clear();
        this.startTimer(time);
    }

    public increaseBy(time: number) {
        this.additionalTimers.push(time);
    }

    public clear() {
        clearTimeout(this.primaryTimer);
        this.additionalTimers.forEach((timer) => clearTimeout(timer));
    }

    private startTimer(time: number) {
        this.primaryTimer = window.setTimeout(() => this.check(), time);
    }

    private check() {
        if (!this.additionalTimers.length) {
            return this.callback();
        }
        this.startTimer(this.additionalTimers.shift() ?? 0);
    }
}
